import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { isEmpty } from '@backmarket/utils/object/isEmpty'

import { SALES_CUSTOMER_CARE_SCOPE } from '@/scopes/care-commons/utils/logger/salesCustomerCare/config'
import { useSalesCustomerCareLogger } from '@/scopes/care-commons/utils/logger/salesCustomerCare/useSalesCustomerCareLogger'
import type { GetActionQueryParams } from '~/api/help-center/types/Problem.types'

import type { MachineContext } from '../Diagnosis.machine.types'
import { getAllSelectedCustomerIssuesWithAction } from '../selectors/getAllSelectedIssues'

export const getAction = async ({
  orderlineId,
  pageData,
}: {
  orderlineId: MachineContext['orderlineId']
  pageData: MachineContext['pageData']
}) => {
  const { logFeatureError } = useSalesCustomerCareLogger()
  const $httpFetch = useHttpFetch()

  const allSelectedCustomerIssuesWithAction =
    getAllSelectedCustomerIssuesWithAction(pageData)

  const params: GetActionQueryParams = {
    customerIssues:
      allSelectedCustomerIssuesWithAction.selectedIssues.join(';'),

    orderlineId: orderlineId as number,
  }

  const payload = await $httpFetch(
    '/help-center/api/v1/auth/diagnosis/problem',
    {
      query: {
        ...params,
      },
    },
  )

  if (!isEmpty(payload)) {
    return payload.action
  }

  logFeatureError({
    errorTitle: `${SALES_CUSTOMER_CARE_SCOPE.diagnosis} get action service no action found`,
    errorDetail: {
      orderline_id: params.orderlineId,
      customer_issues: params.customerIssues,
    },
    featureName: 'diagnosis_get_action_service_no_action_found',
  })

  throw new Error('No action found')
}
